<template>
  <div id="Login">
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title">系统登录</h3>
      <el-form-item prop="username">
        <el-input
          type="text"
          v-model="ruleForm2.username"
          auto-complete="off"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="ruleForm2.password"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <!-- <el-checkbox 
                v-model="checked"
                class="rememberme"
            >记住密码</el-checkbox> -->
      <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;"
          @click="handleSubmit"
          :loading="logining"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { carBrand, getADMIN } from "./../axios/api";
import { allRouter } from "../router/route.js";
export default {
  name: "Login",
  data() {
    return {
      logining: false,
      ruleForm2: {
        username: "",
        password: ""
      },
      rules2: {
        username: [
          { required: true, message: "请输入您的账号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入您的密码", trigger: "blur" }
        ]
      }
      // checked: false
    };
  },
  methods: {
    handleSubmit(event) {
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          this.logining = true;
          var _this = this;

          getADMIN
            .login(
              JSON.stringify({
                username: _this.ruleForm2.username,
                password: _this.ruleForm2.password
              })
            )
            .then(function(res) {
              console.log(res);
              if (res.code !== 0) {
                _this.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {
                    _this.logining = false;
                  }
                });
              } else {
                let { token, rule } = res.data;
                _this.logining = false;
                localStorage.setItem("username2", _this.ruleForm2.username);
                localStorage.setItem("token", token);
                localStorage.setItem("token2", "CNC-admin");
                localStorage.setItem("lastTime2", new Date().getTime());

                let rules = rule.toString();
                // var rule1 = 'Cplx,Mjgl,Zbcp,Zbkh,Yys,Md,Video,Img,Carmodel,Banner,Js,Xw,Bjgl,CarBrand,Cpjm,Ppsp';
                var rule1 =
                  "Cplx,Mjgl,Zbcp,Yys,Md,Sgal,Carmodel,Banner,Bjgl,CarBrand,Cpjm,Js,Our,Xw";
                // console.log('Cplx,'+ rules)
                localStorage.setItem("route2", rule1);
                _this.$router.push({ path: "/none" });
              }
            })
            .catch(function(res) {
              console.log(res);
              // console.log(res.response.data)
              _this.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
                callback: action => {
                  _this.logining = false;
                }
              });
            });
        } else {
          console.log("error submit!");
          return false;
        }
      });
    }
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.handleSubmit(); // 登录方法名
        return false;
      }
    };
  }
};
</script>
<style scoped>
#Login {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title {
  margin-bottom: 30px;
}
.login-container {
  width: 100%;
  height: 100%;
}
.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin: 0;
  width: 350px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue